import { createStore } from 'vuex'
import navBar from '@/store/modules/NavBar.js'
import monthlyExpenses from '@/store/modules/MonthlyExpenses.js'
import helpers from '@/store/modules/Helpers.js'
import nextSteps from '@/store/modules/NextSteps.js'
import monthlyCashFlow from '@/store/modules/MonthlyCashFlow.js'
import userHistory from '@/store/modules/History.js'
import userServiceSubscriptions from '@/store/modules/UserServiceSubscriptions.js'
import dashboard from '@/store/modules/Otivo/Dashboard'
import retirementCalculatorErrorStore from '@/store/modules/RetirementCalculatorErrorStore'
import contentStore from '@/store/modules/ContentStore'
import financialWellBeingCheckInStore from '@/store/modules/FinancialWellBeingCheckInStore'

export const store = createStore({
  modules: {
    ContentStore: contentStore,
    FinancialWellBeingCheckInStore: financialWellBeingCheckInStore,
    RetirementCalculatorErrors: retirementCalculatorErrorStore,
    contentStore: contentStore,
    dashboard: dashboard,
    helpers: helpers,
    monthlyCashFlow: monthlyCashFlow,
    monthlyExpenses: monthlyExpenses,
    navBar: navBar,
    nextSteps: nextSteps,
    userHistory: userHistory,
    userServiceSubscriptions: userServiceSubscriptions,
  },
})
